module.exports = __webpack_public_path__ + "static/media/bellabyte-uniforme-polo-personalizado.6cecdb5f.jpg";